var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSetting(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.2534 7.22659L18.3601 3.23992C17.0401 2.47992 14.9734 2.47992 13.6534 3.23992L6.69344 7.25325C3.93344 9.11992 3.77344 9.39992 3.77344 12.3733V19.6133C3.77344 22.5866 3.93344 22.8799 6.74677 24.7733L13.6401 28.7599C14.3068 29.1466 15.1601 29.3333 16.0001 29.3333C16.8401 29.3333 17.6934 29.1466 18.3468 28.7599L25.3068 24.7466C28.0668 22.8799 28.2268 22.5999 28.2268 19.6266V12.3733C28.2268 9.39992 28.0668 9.11992 25.2534 7.22659ZM16.0001 20.3333C13.6134 20.3333 11.6668 18.3866 11.6668 15.9999C11.6668 13.6133 13.6134 11.6666 16.0001 11.6666C18.3868 11.6666 20.3334 13.6133 20.3334 15.9999C20.3334 18.3866 18.3868 20.3333 16.0001 20.3333Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSetting);
export default __webpack_public_path__ + "static/media/Setting.e6dc63de2e6fa19c8597e816515530af.svg";
export { ForwardRef as ReactComponent };